import * as React from 'react'

export type VignetteCorner =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right'

export type VignetteCornerProp = VignetteCorner | 'random'

export type VignetteSize = 'small' | 'medium' | 'large'

const corners: VignetteCorner[] = [
  'top-left',
  'top-right',
  'bottom-left',
  'bottom-right',
]

interface UseVignetteProps {
  size?: VignetteSize
  darkCorner?: VignetteCornerProp
  darkCornerSize?: VignetteSize
}

export const useVignette = ({
  size = 'medium',
  darkCorner,
  darkCornerSize = 'medium',
}: UseVignetteProps) => {
  const randomCorner = React.useMemo<VignetteCorner>(() => {
    return corners[Math.floor(Math.random() * corners.length)]
  }, [])

  const corner: VignetteCorner =
    !darkCorner || darkCorner === 'random' ? randomCorner : darkCorner

  return {
    corner,
    size,
    darkCornerSize,
  }
}
